__webpack_require__.p = "https://www.highsnobiety.com/static-assets/interactive-stories/2025-04-trident-article-3/";